const prettierNumber = (num: number): string => {
  if (num === undefined || num === null) {
    return '-';
  }

  if (typeof num === 'string') {
    num = Number(num);
  }

  let [integerPart, decimalPart] = num.toFixed(2).split('.');
  let result = '';

  while (integerPart.length > 0) {
    let chunk = integerPart.slice(-3);
    result = chunk + (result ? ' ' + result : '');
    integerPart = integerPart.slice(0, -3);
  }

  if (decimalPart && parseInt(decimalPart) > 0) {
    return `${result}.${decimalPart}`;
  } else {
    return result;
  }
};

export default prettierNumber;
